/** Copyright (c) 2019 T. Rowe Price. All rights reserved. */

import './AddressTypeSelect.scss';

import { func, shape, string } from 'prop-types';
import React from 'react';

import Radio from 'components/shared/Radio/Radio';

const addressTypeOptions = [
  {
    label: 'US',
    value: 'us'
  },
  {
    label: 'Military',
    value: 'military'
  },
  {
    label: 'Non-US',
    value: 'non-us'
  }
];

export const AddressOption = ({ onClick, option, selected, mailingType }) => (
  <label
    className="address-radio-option"
    htmlFor={`${option.value}-${mailingType}-option`}
    onClick={onClick}>
    <Radio
      checked={option.value === selected}
      name={`${option.value}-${mailingType}-option`}
      dataTestId={`${option.value}-${mailingType}-option`}
    />
    {option.label}
  </label>
);

AddressOption.propTypes = {
  onClick: func.isRequired,
  option: shape({
    label: string.isRequired,
    value: string.isRequired
  }),
  selected: string.isRequired
};

const AddressTypeSelect = ({ onChange, selected, mailingType }) => (
  <div className="address-radio-options">
    {addressTypeOptions.map((option, idx) => {
      const onClick = () => onChange('addressType', option.value);
      return (
        <AddressOption
          key={`${mailingType}-${idx}`}
          onClick={onClick}
          option={option}
          selected={selected}
          mailingType={mailingType}
        />
      );
    })}
  </div>
);

AddressTypeSelect.propTypes = {
  onChange: func.isRequired,
  selected: string.isRequired
};

export default AddressTypeSelect;
